/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `AF` - Afghánistán * `AX` - Alandy * `AL` - Albánie * `DZ` - Alžírsko * `AS` - Americká Samoa * `VI` - Americké Panenské ostrovy * `AD` - Andorra * `AO` - Angola * `AI` - Anguilla * `AQ` - Antarktida * `AG` - Antigua a Barbuda * `AR` - Argentina * `AM` - Arménie * `AW` - Aruba * `AU` - Austrálie * `AZ` - Ázerbájdžán * `BS` - Bahamy * `BH` - Bahrajn * `BD` - Bangladéš * `BB` - Barbados * `BE` - Belgie * `BZ` - Belize * `BY` - Bělorusko * `BJ` - Benin * `BM` - Bermudy * `BT` - Bhútán * `BO` - Bolívie * `BQ` - Bonaire, Svatý Eustach a Saba * `BA` - Bosna a Hercegovina * `BW` - Botswana * `BV` - Bouvetův ostrov * `BR` - Brazílie * `VG` - Britské Panenské ostrovy * `IO` - Britské indickooceánské území * `BN` - Brunej * `BG` - Bulharsko * `BF` - Burkina Faso * `BI` - Burundi * `TD` - Čad * `ME` - Černá Hora * `CZ` - Česko * `CL` - Chile * `HR` - Chorvatsko * `CN` - Čína * `CK` - Cookovy ostrovy * `CW` - Curaçao * `DK` - Dánsko * `DM` - Dominika * `DO` - Dominikánská republika * `DJ` - Džibutsko * `EG` - Egypt * `EC` - Ekvádor * `ER` - Eritrea * `EE` - Estonsko * `SZ` - Eswatini * `ET` - Etiopie * `FO` - Faerské ostrovy * `FK` - Falklandy (Malvíny) * `FJ` - Fidži * `PH` - Filipíny * `FI` - Finsko * `FR` - Francie * `GF` - Francouzská Guyana * `PF` - Francouzská Polynésie * `TF` - Francouzská jižní a antarktická území * `GA` - Gabon * `GM` - Gambie * `GH` - Ghana * `GI` - Gibraltar * `GD` - Grenada * `GL` - Grónsko * `GE` - Gruzie * `GP` - Guadeloupe * `GU` - Guam * `GT` - Guatemala * `GG` - Guernsey * `GN` - Guinea * `GW` - Guinea-Bissau * `GY` - Guyana * `HT` - Haiti * `HM` - Heardův ostrov a McDonaldovy ostrovy * `HN` - Honduras * `HK` - Hongkong * `IN` - Indie * `ID` - Indonésie * `IQ` - Irák * `IR` - Írán * `IE` - Irsko * `IS` - Island * `IT` - Itálie * `IL` - Izrael * `JM` - Jamajka * `JP` - Japonsko * `YE` - Jemen * `JE` - Jersey * `ZA` - Jižní Afrika * `GS` - Jižní Georgie a Jižní Sandwichovy ostrovy * `KR` - Jižní Korea * `SS` - Jižní Súdán * `JO` - Jordánsko * `KY` - Kajmanské ostrovy * `KH` - Kambodža * `CM` - Kamerun * `CA` - Kanada * `CV` - Kapverdy * `QA` - Katar * `KZ` - Kazachstán * `KE` - Keňa * `KI` - Kiribati * `CC` - Kokosové (Keelingovy) ostrovy * `CO` - Kolumbie * `KM` - Komory * `CG` - Kongo * `CD` - Kongo, demokratická republika * `CR` - Kostarika * `CU` - Kuba * `KW` - Kuvajt * `CY` - Kypr * `KG` - Kyrgyzstán * `LA` - Laos * `LS` - Lesotho * `LB` - Libanon * `LR` - Libérie * `LY` - Libye * `LI` - Lichtenštejnsko * `LT` - Litva * `LV` - Lotyšsko * `LU` - Lucembursko * `MO` - Macao * `MG` - Madagaskar * `HU` - Maďarsko * `MY` - Malajsie * `MW` - Malawi * `MV` - Maledivy * `ML` - Mali * `MT` - Malta * `MA` - Maroko * `MH` - Marshallovy ostrovy * `MQ` - Martinik * `MU` - Mauricius * `MR` - Mauritánie * `YT` - Mayotte * `UM` - Menší odlehlé ostrovy USA * `MX` - Mexiko * `FM` - Mikronésie * `MD` - Moldavsko * `MC` - Monako * `MN` - Mongolsko * `MS` - Montserrat * `MZ` - Mosambik * `MM` - Myanma * `NA` - Namibie * `NR` - Nauru * `DE` - Německo * `NP` - Nepál * `NE` - Niger * `NG` - Nigérie * `NI` - Nikaragua * `NU` - Niue * `NL` - Nizozemsko * `NO` - Norsko * `NC` - Nová Kaledonie * `NZ` - Nový Zéland * `OM` - Omán * `IM` - Ostrov Man * `NF` - Ostrov Norfolk * `MP` - Ostrovy Severní Mariany * `TC` - Ostrovy Turks a Caicos * `PK` - Pákistán * `PW` - Palau * `PS` - Palestinské území (okupované) * `PA` - Panama * `PG` - Papua Nová Guinea * `PY` - Paraguay * `PE` - Peru * `PN` - Pitcairn * `CI` - Pobřeží Slonoviny * `PL` - Polsko * `PR` - Portoriko * `PT` - Portugalsko * `AT` - Rakousko * `GR` - Řecko * `RE` - Réunion * `GQ` - Rovníková Guinea * `RO` - Rumunsko * `RU` - Rusko * `RW` - Rwanda * `PM` - Saint Pierre a Miquelon * `SB` - Šalomounovy ostrovy * `SV` - Salvador * `WS` - Samoa * `SM` - San Marino * `SA` - Saúdská Arábie * `SN` - Senegal * `KP` - Severní Korea * `MK` - Severní Makedonie * `SC` - Seychely * `SL` - Sierra Leone * `SG` - Singapur * `SK` - Slovensko * `SI` - Slovinsko * `SO` - Somálsko * `ES` - Španělsko * `AE` - Spojené arabské emiráty * `GB` - Spojené království * `US` - Spojené státy americké * `RS` - Srbsko * `LK` - Srí Lanka * `CF` - Středoafrická republika * `SD` - Súdán * `SR` - Surinam * `SJ` - Svalbard a Jan Mayen * `SH` - Svatá Helena, Ascension a Tristan da Cunha * `LC` - Svatá Lucie * `BL` - Svatý Bartoloměj * `KN` - Svatý Kryštof a Nevis * `MF` - Svatý Martin (francouzská část) * `SX` - Svatý Martin (nizozemská část) * `ST` - Svatý Tomáš a Princův ostrov * `VC` - Svatý Vincenc a Grenadiny * `SE` - Švédsko * `CH` - Švýcarsko * `SY` - Sýrie * `TJ` - Tádžikistán * `TW` - Taiwan * `TZ` - Tanzánie * `TH` - Thajsko * `TG` - Togo * `TK` - Tokelau * `TO` - Tonga * `TT` - Trinidad a Tobago * `TN` - Tunisko * `TR` - Turecko * `TM` - Turkmenistán * `TV` - Tuvalu * `UG` - Uganda * `UA` - Ukrajina * `UY` - Uruguay * `UZ` - Uzbekistán * `CX` - Vánoční ostrov * `VU` - Vanuatu * `VA` - Vatikán * `VE` - Venezuela * `VN` - Vietnam * `TL` - Východní Timor * `WF` - Wallis a Futuna * `ZM` - Zambie * `EH` - Západní Sahara * `ZW` - Zimbabwe
 */
export type CountryEnum = 'AF' | 'AX' | 'AL' | 'DZ' | 'AS' | 'VI' | 'AD' | 'AO' | 'AI' | 'AQ' | 'AG' | 'AR' | 'AM' | 'AW' | 'AU' | 'AZ' | 'BS' | 'BH' | 'BD' | 'BB' | 'BE' | 'BZ' | 'BY' | 'BJ' | 'BM' | 'BT' | 'BO' | 'BQ' | 'BA' | 'BW' | 'BV' | 'BR' | 'VG' | 'IO' | 'BN' | 'BG' | 'BF' | 'BI' | 'TD' | 'ME' | 'CZ' | 'CL' | 'HR' | 'CN' | 'CK' | 'CW' | 'DK' | 'DM' | 'DO' | 'DJ' | 'EG' | 'EC' | 'ER' | 'EE' | 'SZ' | 'ET' | 'FO' | 'FK' | 'FJ' | 'PH' | 'FI' | 'FR' | 'GF' | 'PF' | 'TF' | 'GA' | 'GM' | 'GH' | 'GI' | 'GD' | 'GL' | 'GE' | 'GP' | 'GU' | 'GT' | 'GG' | 'GN' | 'GW' | 'GY' | 'HT' | 'HM' | 'HN' | 'HK' | 'IN' | 'ID' | 'IQ' | 'IR' | 'IE' | 'IS' | 'IT' | 'IL' | 'JM' | 'JP' | 'YE' | 'JE' | 'ZA' | 'GS' | 'KR' | 'SS' | 'JO' | 'KY' | 'KH' | 'CM' | 'CA' | 'CV' | 'QA' | 'KZ' | 'KE' | 'KI' | 'CC' | 'CO' | 'KM' | 'CG' | 'CD' | 'CR' | 'CU' | 'KW' | 'CY' | 'KG' | 'LA' | 'LS' | 'LB' | 'LR' | 'LY' | 'LI' | 'LT' | 'LV' | 'LU' | 'MO' | 'MG' | 'HU' | 'MY' | 'MW' | 'MV' | 'ML' | 'MT' | 'MA' | 'MH' | 'MQ' | 'MU' | 'MR' | 'YT' | 'UM' | 'MX' | 'FM' | 'MD' | 'MC' | 'MN' | 'MS' | 'MZ' | 'MM' | 'NA' | 'NR' | 'DE' | 'NP' | 'NE' | 'NG' | 'NI' | 'NU' | 'NL' | 'NO' | 'NC' | 'NZ' | 'OM' | 'IM' | 'NF' | 'MP' | 'TC' | 'PK' | 'PW' | 'PS' | 'PA' | 'PG' | 'PY' | 'PE' | 'PN' | 'CI' | 'PL' | 'PR' | 'PT' | 'AT' | 'GR' | 'RE' | 'GQ' | 'RO' | 'RU' | 'RW' | 'PM' | 'SB' | 'SV' | 'WS' | 'SM' | 'SA' | 'SN' | 'KP' | 'MK' | 'SC' | 'SL' | 'SG' | 'SK' | 'SI' | 'SO' | 'ES' | 'AE' | 'GB' | 'US' | 'RS' | 'LK' | 'CF' | 'SD' | 'SR' | 'SJ' | 'SH' | 'LC' | 'BL' | 'KN' | 'MF' | 'SX' | 'ST' | 'VC' | 'SE' | 'CH' | 'SY' | 'TJ' | 'TW' | 'TZ' | 'TH' | 'TG' | 'TK' | 'TO' | 'TT' | 'TN' | 'TR' | 'TM' | 'TV' | 'UG' | 'UA' | 'UY' | 'UZ' | 'CX' | 'VU' | 'VA' | 'VE' | 'VN' | 'TL' | 'WF' | 'ZM' | 'EH' | 'ZW';

export const CountryEnum = {
    AF: 'AF' as CountryEnum,
    AX: 'AX' as CountryEnum,
    AL: 'AL' as CountryEnum,
    DZ: 'DZ' as CountryEnum,
    AS: 'AS' as CountryEnum,
    VI: 'VI' as CountryEnum,
    AD: 'AD' as CountryEnum,
    AO: 'AO' as CountryEnum,
    AI: 'AI' as CountryEnum,
    AQ: 'AQ' as CountryEnum,
    AG: 'AG' as CountryEnum,
    AR: 'AR' as CountryEnum,
    AM: 'AM' as CountryEnum,
    AW: 'AW' as CountryEnum,
    AU: 'AU' as CountryEnum,
    AZ: 'AZ' as CountryEnum,
    BS: 'BS' as CountryEnum,
    BH: 'BH' as CountryEnum,
    BD: 'BD' as CountryEnum,
    BB: 'BB' as CountryEnum,
    BE: 'BE' as CountryEnum,
    BZ: 'BZ' as CountryEnum,
    BY: 'BY' as CountryEnum,
    BJ: 'BJ' as CountryEnum,
    BM: 'BM' as CountryEnum,
    BT: 'BT' as CountryEnum,
    BO: 'BO' as CountryEnum,
    BQ: 'BQ' as CountryEnum,
    BA: 'BA' as CountryEnum,
    BW: 'BW' as CountryEnum,
    BV: 'BV' as CountryEnum,
    BR: 'BR' as CountryEnum,
    VG: 'VG' as CountryEnum,
    IO: 'IO' as CountryEnum,
    BN: 'BN' as CountryEnum,
    BG: 'BG' as CountryEnum,
    BF: 'BF' as CountryEnum,
    BI: 'BI' as CountryEnum,
    TD: 'TD' as CountryEnum,
    ME: 'ME' as CountryEnum,
    CZ: 'CZ' as CountryEnum,
    CL: 'CL' as CountryEnum,
    HR: 'HR' as CountryEnum,
    CN: 'CN' as CountryEnum,
    CK: 'CK' as CountryEnum,
    CW: 'CW' as CountryEnum,
    DK: 'DK' as CountryEnum,
    DM: 'DM' as CountryEnum,
    DO: 'DO' as CountryEnum,
    DJ: 'DJ' as CountryEnum,
    EG: 'EG' as CountryEnum,
    EC: 'EC' as CountryEnum,
    ER: 'ER' as CountryEnum,
    EE: 'EE' as CountryEnum,
    SZ: 'SZ' as CountryEnum,
    ET: 'ET' as CountryEnum,
    FO: 'FO' as CountryEnum,
    FK: 'FK' as CountryEnum,
    FJ: 'FJ' as CountryEnum,
    PH: 'PH' as CountryEnum,
    FI: 'FI' as CountryEnum,
    FR: 'FR' as CountryEnum,
    GF: 'GF' as CountryEnum,
    PF: 'PF' as CountryEnum,
    TF: 'TF' as CountryEnum,
    GA: 'GA' as CountryEnum,
    GM: 'GM' as CountryEnum,
    GH: 'GH' as CountryEnum,
    GI: 'GI' as CountryEnum,
    GD: 'GD' as CountryEnum,
    GL: 'GL' as CountryEnum,
    GE: 'GE' as CountryEnum,
    GP: 'GP' as CountryEnum,
    GU: 'GU' as CountryEnum,
    GT: 'GT' as CountryEnum,
    GG: 'GG' as CountryEnum,
    GN: 'GN' as CountryEnum,
    GW: 'GW' as CountryEnum,
    GY: 'GY' as CountryEnum,
    HT: 'HT' as CountryEnum,
    HM: 'HM' as CountryEnum,
    HN: 'HN' as CountryEnum,
    HK: 'HK' as CountryEnum,
    IN: 'IN' as CountryEnum,
    ID: 'ID' as CountryEnum,
    IQ: 'IQ' as CountryEnum,
    IR: 'IR' as CountryEnum,
    IE: 'IE' as CountryEnum,
    IS: 'IS' as CountryEnum,
    IT: 'IT' as CountryEnum,
    IL: 'IL' as CountryEnum,
    JM: 'JM' as CountryEnum,
    JP: 'JP' as CountryEnum,
    YE: 'YE' as CountryEnum,
    JE: 'JE' as CountryEnum,
    ZA: 'ZA' as CountryEnum,
    GS: 'GS' as CountryEnum,
    KR: 'KR' as CountryEnum,
    SS: 'SS' as CountryEnum,
    JO: 'JO' as CountryEnum,
    KY: 'KY' as CountryEnum,
    KH: 'KH' as CountryEnum,
    CM: 'CM' as CountryEnum,
    CA: 'CA' as CountryEnum,
    CV: 'CV' as CountryEnum,
    QA: 'QA' as CountryEnum,
    KZ: 'KZ' as CountryEnum,
    KE: 'KE' as CountryEnum,
    KI: 'KI' as CountryEnum,
    CC: 'CC' as CountryEnum,
    CO: 'CO' as CountryEnum,
    KM: 'KM' as CountryEnum,
    CG: 'CG' as CountryEnum,
    CD: 'CD' as CountryEnum,
    CR: 'CR' as CountryEnum,
    CU: 'CU' as CountryEnum,
    KW: 'KW' as CountryEnum,
    CY: 'CY' as CountryEnum,
    KG: 'KG' as CountryEnum,
    LA: 'LA' as CountryEnum,
    LS: 'LS' as CountryEnum,
    LB: 'LB' as CountryEnum,
    LR: 'LR' as CountryEnum,
    LY: 'LY' as CountryEnum,
    LI: 'LI' as CountryEnum,
    LT: 'LT' as CountryEnum,
    LV: 'LV' as CountryEnum,
    LU: 'LU' as CountryEnum,
    MO: 'MO' as CountryEnum,
    MG: 'MG' as CountryEnum,
    HU: 'HU' as CountryEnum,
    MY: 'MY' as CountryEnum,
    MW: 'MW' as CountryEnum,
    MV: 'MV' as CountryEnum,
    ML: 'ML' as CountryEnum,
    MT: 'MT' as CountryEnum,
    MA: 'MA' as CountryEnum,
    MH: 'MH' as CountryEnum,
    MQ: 'MQ' as CountryEnum,
    MU: 'MU' as CountryEnum,
    MR: 'MR' as CountryEnum,
    YT: 'YT' as CountryEnum,
    UM: 'UM' as CountryEnum,
    MX: 'MX' as CountryEnum,
    FM: 'FM' as CountryEnum,
    MD: 'MD' as CountryEnum,
    MC: 'MC' as CountryEnum,
    MN: 'MN' as CountryEnum,
    MS: 'MS' as CountryEnum,
    MZ: 'MZ' as CountryEnum,
    MM: 'MM' as CountryEnum,
    NA: 'NA' as CountryEnum,
    NR: 'NR' as CountryEnum,
    DE: 'DE' as CountryEnum,
    NP: 'NP' as CountryEnum,
    NE: 'NE' as CountryEnum,
    NG: 'NG' as CountryEnum,
    NI: 'NI' as CountryEnum,
    NU: 'NU' as CountryEnum,
    NL: 'NL' as CountryEnum,
    NO: 'NO' as CountryEnum,
    NC: 'NC' as CountryEnum,
    NZ: 'NZ' as CountryEnum,
    OM: 'OM' as CountryEnum,
    IM: 'IM' as CountryEnum,
    NF: 'NF' as CountryEnum,
    MP: 'MP' as CountryEnum,
    TC: 'TC' as CountryEnum,
    PK: 'PK' as CountryEnum,
    PW: 'PW' as CountryEnum,
    PS: 'PS' as CountryEnum,
    PA: 'PA' as CountryEnum,
    PG: 'PG' as CountryEnum,
    PY: 'PY' as CountryEnum,
    PE: 'PE' as CountryEnum,
    PN: 'PN' as CountryEnum,
    CI: 'CI' as CountryEnum,
    PL: 'PL' as CountryEnum,
    PR: 'PR' as CountryEnum,
    PT: 'PT' as CountryEnum,
    AT: 'AT' as CountryEnum,
    GR: 'GR' as CountryEnum,
    RE: 'RE' as CountryEnum,
    GQ: 'GQ' as CountryEnum,
    RO: 'RO' as CountryEnum,
    RU: 'RU' as CountryEnum,
    RW: 'RW' as CountryEnum,
    PM: 'PM' as CountryEnum,
    SB: 'SB' as CountryEnum,
    SV: 'SV' as CountryEnum,
    WS: 'WS' as CountryEnum,
    SM: 'SM' as CountryEnum,
    SA: 'SA' as CountryEnum,
    SN: 'SN' as CountryEnum,
    KP: 'KP' as CountryEnum,
    MK: 'MK' as CountryEnum,
    SC: 'SC' as CountryEnum,
    SL: 'SL' as CountryEnum,
    SG: 'SG' as CountryEnum,
    SK: 'SK' as CountryEnum,
    SI: 'SI' as CountryEnum,
    SO: 'SO' as CountryEnum,
    ES: 'ES' as CountryEnum,
    AE: 'AE' as CountryEnum,
    GB: 'GB' as CountryEnum,
    US: 'US' as CountryEnum,
    RS: 'RS' as CountryEnum,
    LK: 'LK' as CountryEnum,
    CF: 'CF' as CountryEnum,
    SD: 'SD' as CountryEnum,
    SR: 'SR' as CountryEnum,
    SJ: 'SJ' as CountryEnum,
    SH: 'SH' as CountryEnum,
    LC: 'LC' as CountryEnum,
    BL: 'BL' as CountryEnum,
    KN: 'KN' as CountryEnum,
    MF: 'MF' as CountryEnum,
    SX: 'SX' as CountryEnum,
    ST: 'ST' as CountryEnum,
    VC: 'VC' as CountryEnum,
    SE: 'SE' as CountryEnum,
    CH: 'CH' as CountryEnum,
    SY: 'SY' as CountryEnum,
    TJ: 'TJ' as CountryEnum,
    TW: 'TW' as CountryEnum,
    TZ: 'TZ' as CountryEnum,
    TH: 'TH' as CountryEnum,
    TG: 'TG' as CountryEnum,
    TK: 'TK' as CountryEnum,
    TO: 'TO' as CountryEnum,
    TT: 'TT' as CountryEnum,
    TN: 'TN' as CountryEnum,
    TR: 'TR' as CountryEnum,
    TM: 'TM' as CountryEnum,
    TV: 'TV' as CountryEnum,
    UG: 'UG' as CountryEnum,
    UA: 'UA' as CountryEnum,
    UY: 'UY' as CountryEnum,
    UZ: 'UZ' as CountryEnum,
    CX: 'CX' as CountryEnum,
    VU: 'VU' as CountryEnum,
    VA: 'VA' as CountryEnum,
    VE: 'VE' as CountryEnum,
    VN: 'VN' as CountryEnum,
    TL: 'TL' as CountryEnum,
    WF: 'WF' as CountryEnum,
    ZM: 'ZM' as CountryEnum,
    EH: 'EH' as CountryEnum,
    ZW: 'ZW' as CountryEnum
};